import PropTypes from 'prop-types';

export const sponsorPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    logo_url: PropTypes.string,
    tagline: PropTypes.string,
    description: PropTypes.string,
    city_name: PropTypes.string,
    state_name: PropTypes.string,
    country_name: PropTypes.string,
});
